import type { AfcSubmission } from '@axiom/validation';
import {
  CandidateOpportunitiesConst,
  ContactsOpportunitiesConst,
} from '@axiom/const';

const { CandidateStatuses } = CandidateOpportunitiesConst;

const setData = (
  submission: AfcSubmission,
  isInterviewing = false
): AfcSubmission => {
  return {
    ...submission,
    positions: submission.positions.map(position => {
      return {
        ...position,
        candidateOpportunities: position.candidateOpportunities.filter(co => {
          return isInterviewing
            ? co.candidateStatus === CandidateStatuses.Interviewing
            : co.candidateStatus !== CandidateStatuses.Interviewing;
        }),
      };
    }),
  };
};

export const SubmissionsUtil = {
  getInterviewingCandidates: (
    submission?: AfcSubmission
  ): AfcSubmission | null => {
    return !submission || Object.keys(submission).length === 0
      ? null
      : setData(submission, true);
  },

  getNonInterviewingCandidates: (
    submission?: AfcSubmission
  ): AfcSubmission | null => {
    return !submission || Object.keys(submission).length === 0
      ? null
      : setData(submission, false);
  },

  getPrimaryOwnerId: (submission?: AfcSubmission): string | undefined => {
    return submission?.contacts?.find(
      contact => contact.displayRole === ContactsOpportunitiesConst.Roles.Owner
    )?.id;
  },
};
